import { CapitalizeNames as capitalize } from 'src/utils/capitalize';
import { ISource } from 'src/interfaces/source';
import { TSelectItem } from '../components/types';

/**
 * Maps the sources to a select item
 *
 * @param {ISource[]} sources
 * @return {*}  {TSelectItem[]}
 */
export const mapSources = (sources: ISource[]): TSelectItem[] =>
    sources.map((source) => ({
        value: source._id,
        label: capitalize(source.name),
    }));
